import React from 'react';

export const CopyIcon = () => {

    return (
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
<path fillRule="evenodd" clipRule="evenodd" d="M8.38947 4.16061H5.57059V3.85704C5.57059 2.51578 6.6579 1.42847 7.99916 1.42847H11.642C12.9833 1.42847 14.0706 2.51578 14.0706 3.85704V7.4999C14.0706 8.84116 12.9833 9.92847 11.642 9.92847H11.3384V7.10959C11.3384 5.48091 10.0181 4.16061 8.38947 4.16061ZM7.99916 13.5713H4.35631C3.01504 13.5713 1.92773 12.484 1.92773 11.1428V7.4999C1.92773 6.15863 3.01504 5.07132 4.35631 5.07132H7.99916C9.34043 5.07132 10.4277 6.15863 10.4277 7.4999V11.1428C10.4277 12.484 9.34043 13.5713 7.99916 13.5713Z" fill="#3452F4"/>
</svg>
    )
}

